import { useTranslation } from "react-i18next";
import { Alert, Box, Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";
import { BusinessOutlined as BusinessIcon } from "@mui/icons-material"
import { useMission } from "../../../../providers/MissionProvider";
import { GetTaskLabel } from "../../../../common/mission";

export default function AdjustRequestSection(props) {
  const {
    includeOwner,
    setIncludeOwner,
    includeRequester,
    setIncludeRequester,
    message,
    setMessage,
    service,
    setService,
    selectedStation,
    expectedDone,
    setExpectedDone,
    overrideRequester, 
    setOverrideRequester,
  } = props;

  const { t } = useTranslation();
  const { mission } = useMission();

  return (
    <Box sx={{ height: "100%" }}>
      <Stack spacing={2}>

        <Alert variant="outlined" severity="info" icon={<BusinessIcon />} sx={{ marginBottom: 1, borderRadius: "8px !important" }}>
          {t("missionRequests:adjustRequest:to")}: {selectedStation?.displayName}
        </Alert>

        <TextField
          label={t("missionRequests:adjustRequest:message")}
          variant="filled"
          value={message}
          onChange={ev => setMessage(ev.target.value)}
          fullWidth
          minRows={2}
          multiline
          size="small"
        />

        <TextField
          label={t("missionRequests:adjustRequest:expectedDone")}
          variant="filled"
          value={expectedDone}
          onChange={ev => setExpectedDone(ev.target.value)}
          fullWidth
          size="small"
        />

        <FormControl fullWidth size="small" variant="filled">
          <InputLabel>{t("missionRequests:adjustRequest:service")}</InputLabel>
          <Select onChange={ev => setService(ev.target.value)} value={service}>
            {!service ? <MenuItem value="">{t("missionRequests:adjustRequest:noService")}</MenuItem> : null}

            {mission?.salvageTasks.map((task, idx) => {
              return (
                <MenuItem key={idx} value={task.taskId}>
                  {GetTaskLabel(task, t)}
                </MenuItem>
              );
            })}

          </Select>
        </FormControl>

        <FormControl>
          <FormGroup>
            <FormControlLabel
              label={t("missionRequests:adjustRequest:includeOwner")}
              control={
                <Checkbox
                  checked={includeOwner}
                  onChange={ev => setIncludeOwner(ev.target.checked)}
                />
              }
            />
            <FormControlLabel
              label={t("missionRequests:adjustRequest:includeRequester")}
              control={
                <Checkbox
                  checked={includeRequester}
                  onChange={ev => setIncludeRequester(ev.target.checked)}
                />
              }
            />
            <FormControlLabel
              label={t("missionRequests:adjustRequest:overrideRequester")}
              disabled={!includeRequester}
              control={
                <Checkbox
                  checked={overrideRequester && includeRequester}
                  onChange={ev => setOverrideRequester(ev.target.checked)}
                />
              }
            />
          </FormGroup>
        </FormControl>


      </Stack>
    </Box>
  );
}

